import { render } from "./item-mappings.vue?vue&type=template&id=de8bc0a0&scoped=true"
import script from "./item-mappings.vue?vue&type=script&lang=js"
export * from "./item-mappings.vue?vue&type=script&lang=js"

import "./item-mappings.vue?vue&type=style&index=0&id=de8bc0a0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de8bc0a0"]])

export default __exports__